import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../services/api";
import editar from "../../assets/editar.png";
import apagar from "../../assets/icons8-apagar-para-sempre-48 (2).png";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "../../components/Pagination/paginationMap";
import { isAdmin } from "../../services/auth";
import "../Grupos/grupos.scss"
import { IoMdAdd } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { CiEdit } from "react-icons/ci";
import { MdDeleteForever } from "react-icons/md";
import Swal from "sweetalert2";
import { red } from "@mui/material/colors";
import Preloader from "../PreloaderGrids/Preloader"
import "../Enfermeiro/enfermeiro.scss"

import logo from "../../assets/logo.png"
import { Layers } from "lucide-react";

import { color } from "@mui/system";


function Cadastro() {
  // Dados exibidos na tabela/lista
  const [marcadores, setMarcadores] = useState([]);

  // Quantidade total de páginas
  const [pages, setPages] = useState([]);

  // Página atualmente selecionada
  const [currentPage, setCurrentPage] = useState(1);

  // Página intermediária usada na paginação
  const [mediaPage, setMediaPage] = useState(2);

  // Quantidade de registros por página
  const [limit, setLimit] = useState(50);

  // Texto digitado para pesquisa/filtro
  const [searchTerm, setSearchTerm] = useState("");

  // Navegação entre rotas
  const navigate = useNavigate();

  // Cor utilizada na paginação
  const colorPagination = "#dee2e6";

  // Total de registros encontrados
  const [totalItems, setTotalItems] = useState(0);

  // IDs ou itens selecionados
  const [selecionados, setSelecionados] = useState([]);

  // Loader inicial da tela
  const [showLoader, setShowLoader] = useState(true);

  // Loader durante troca de página
  const [loadingPage, setLoadingPage] = useState(false);

  // Tipo/permissão do usuário salvo no navegador
  const tipo = localStorage.getItem("tipo");

  // Atualiza a quantidade de registros exibidos por página
  const handleSelecionadas = (valor1) => {
    setLimit(valor1);
  };

  // Controla o loading inicial da tela/componente
  const [loading, setLoading] = useState(true);

  // Cria um atraso assíncrono em milissegundos
  // Usado para pausar execuções com await
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  // Controla se o usuário possui permissão de administrador
  const [isAdminState, setIsAdminState] = useState(false);

  // Seleciona ou remove um item da lista de selecionados
  const handleSelecionar = (id) => {
    if (selecionados.includes(id)) {
      setSelecionados(selecionados.filter((item) => item !== id));
    } else {
      setSelecionados([...selecionados, id]);
    }
  };

  // Seleciona ou desmarca todos os itens da página atual
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const todosIDs = marcadores.map((m) => m.id);
      setSelecionados(todosIDs);
    } else {
      setSelecionados([]);
    }
  };



  // Verifica ao carregar o componente se o usuário possui permissão de administrador
  useEffect(() => {
    const checkAdmin = async () => {

      // Chama função que valida se o usuário é admin
      const response = await isAdmin();

      // Atualiza o estado conforme retorno da API
      if (response.status === "success" && response.isAdmin) {
        setIsAdminState(true);
      } else {
        setIsAdminState(false);
      }
    };

    checkAdmin();
  }, []);


  // Define quais páginas serão exibidas na paginação
  // adicionando "..." quando houver muitas páginas
  function getVisiblePages(currentPage, totalPages) {
    const pages = [];

    // Se houver até 3 páginas, exibe todas
    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {

      // Início da paginação
      // Exemplo: [1, 2, "...", 10]
      if (currentPage <= 2) {
        pages.push(1, 2, "...", totalPages);

        // Final da paginação
        // Exemplo: [1, "...", 9, 10]
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 1, totalPages);

        // Meio da paginação
        // Exemplo: [1, "...", 5, "...", 10]
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  }

  // Cria um atraso assíncrono em milissegundos
  // Usado para pausar execuções com await
  const delayPage = (ms) => new Promise(resolve => setTimeout(resolve, ms));


  // Busca os dados da página atual sempre que:
  // - página mudar
  // - limite de registros mudar
  // - pesquisa mudar
  useEffect(() => {

    // Evita atualizar estados após desmontar o componente
    let mounted = true;

    async function fetchData() {

      // Marca o tempo inicial da requisição
      const start = Date.now();

      // Tempo mínimo do loading para suavizar animação
      const MIN_DELAY = 1500; // 1.5 segundos

      try {

        // Busca dados paginados da API
        const { data } = await api.get(
          `/grupospages?limit=${limit}&page=${currentPage}&searchTerm=${searchTerm}`,
          { headers: { typo: localStorage.getItem("id") } }
        );

        // Atualiza os dados apenas se o componente ainda estiver montado
        if (mounted) {
          const grupos = Array.isArray(data?.grupos?.data)
            ? data.grupos.data
            : [];

          setMarcadores(grupos);
        }

      } catch (err) {

        // Em caso de erro limpa os dados
        if (mounted) setMarcadores([]);

      } finally {

        // Calcula quanto tempo a requisição levou
        const elapsed = Date.now() - start;

        // Mantém o loading visível por um tempo mínimo
        // para evitar flickering visual
        if (elapsed < MIN_DELAY) {
          await delayPage(MIN_DELAY - elapsed);
        }

        // Finaliza animação/loading da página
        if (mounted) {
          setLoadingPage(false);
        }

        setLoading(false);
        setShowLoader(false);
      }
    }

    fetchData();

    // Cleanup para evitar memory leak
    return () => (mounted = false);

  }, [currentPage, limit, searchTerm]);

  // Busca a quantidade total de registros e monta a paginação
  // sempre que o limite ou pesquisa forem alterados
  useEffect(() => {

    async function fetchTotalPages() {
      try {

        // Busca total de registros filtrados
        const { data } = await api.get(`/totalgrupos?searchTerm=${searchTerm}`, {
          headers: {
            typo: localStorage.getItem("id"),
          },
        });

        // Total de itens encontrados
        const total = data.result;
        setTotalItems(total);

        // Calcula quantidade total de páginas
        const totalPages = Math.ceil(total / limit);

        // Cria array de páginas
        // Exemplo: [1,2,3,4,5]
        const arrayPages = Array.from({ length: totalPages }, (_, i) => i + 1);

        setPages(arrayPages);

        // Garante que a página atual não ultrapasse
        // o limite após filtros ou mudanças no limit
        if (currentPage > totalPages) {
          setCurrentPage(1);
          setMediaPage(2);
        }

      } catch (error) {

        // Exibe erro no console caso a requisição falhe
        console.error("Erro ao buscar total de grupos:", error);
      }
    }

    fetchTotalPages();

  }, [limit, searchTerm]);

  // Controla a navegação entre páginas da paginação
  const handlePagination = (page) => {

    // Garante que a página esteja dentro do limite válido
    if (page >= 1 && page <= pages.length) {

      // Ativa animação/loading da troca de página
      setLoadingPage(true);

      // Atualiza página atual
      setCurrentPage(page);

      // Ajusta página intermediária exibida na paginação
      if (page === 1) {

        // Início da paginação
        setMediaPage(2);

      } else if (page === pages.length) {

        // Final da paginação
        setMediaPage(page - 1);

      } else {

        // Meio da paginação
        setMediaPage(page);
      }
    }
  };


  //LIMITES POR PAGINA
  // Atualiza a quantidade de registros exibidos por página
  const limits = useCallback((e) => {

    // Converte valor selecionado para número inteiro
    const newLimit = parseInt(e.target.value, 10);

    // Ativa loading durante atualização da paginação
    setLoadingPage(true);

    // Atualiza limite de registros por página
    setLimit(newLimit);

    // Retorna para primeira página após alteração
    setCurrentPage(1);

    // Reinicia página intermediária da paginação
    setMediaPage(2);

  }, []);

  // Busca dados paginados da API com controle de loader animado
  async function fetchDataCache(limit, currentPage) {

    // Define se o loader deve ser exibido
    const shouldShowLoader = showLoader;

    // Marca tempo inicial da requisição
    const start = Date.now();

    // Ativa loading inicial (fade-in)
    if (shouldShowLoader) {
      setLoading(true);
    }

    try {

      // Busca dados paginados da API
      const { data } = await api.get(
        `/grupospages?limit=${limit}&page=${currentPage}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );

      // Atualiza dados da tabela/lista
      const grupos = Array.isArray(data?.grupos?.data)
        ? data.grupos.data
        : [];

      setMarcadores(grupos);

    } catch (err) {

      // Exibe erro e limpa dados em caso de falha
      console.error(err);
      setMarcadores([]);

    } finally {

      // Controle visual do loader
      if (shouldShowLoader) {

        // Calcula duração da requisição
        const elapsed = Date.now() - start;

        // Tempo mínimo que o loader deve permanecer visível
        const MIN_DELAY = 5000;

        // Evita loader piscando rápido demais
        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        // Inicia animação de fade-out
        setLoading(false);

        // Aguarda transição CSS finalizar
        await delay(1000);

        // Remove loader da tela
        setShowLoader(false);
        setLoading(false);

      }
    }
  }


  //LÓGICA PARA ATIVAR O SCROLL NA TABELA QUANDO A LARGURA FOR MAIOR QUE 300PX

  // Controla se a largura da tela é maior que 300px
  const [smallWidth, setSmallWidth] = useState(false);

  useEffect(() => {

    // Verifica largura atual da janela
    const checkWidth = () => {

      // Atualiza estado conforme tamanho da tela
      setSmallWidth(window.innerWidth > 300);
    };

    // Executa verificação inicial
    checkWidth();

    // Atualiza valor ao redimensionar janela
    window.addEventListener("resize", checkWidth);

    // Remove evento ao desmontar componente
    return () => window.removeEventListener("resize", checkWidth);

  }, []);

  //EDITAR GRUPO

  const handleEditar = async (marcador) => {

    /* =========================================================
       VEÍCULOS DO GRUPO
       ========================================================= */

    const veiculosGrupo =
      marcador?.veiculos ??
      marcador?.placa ??
      "";

    const listaVeiculos =
      Array.isArray(veiculosGrupo)
        ? veiculosGrupo
          .map((veiculo) =>
            String(veiculo)
              .replace(/'/g, "")
              .trim()
          )
          .filter(Boolean)

        : String(veiculosGrupo)
          .split(",")
          .map((veiculo) =>
            veiculo
              .replace(/'/g, "")
              .trim()
          )
          .filter(Boolean);


    /* =========================================================
       CONFIRMAÇÃO DE EDIÇÃO
       ========================================================= */

    const result = await Swal.fire({

      title: "Editar grupo",

      icon: "question",
      iconColor: "#38bdf8",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "520px",
      padding: "1.5rem",

      html: `
      <div class="swal-grupo-edicao">

        <div class="swal-grupo-edicao-description">
          Confira as informações antes de continuar.
        </div>


        <div class="swal-grupo-edicao-data">

          <!-- NOME -->
          <div class="swal-grupo-edicao-item">

            <span class="swal-grupo-edicao-label">
              Nome do grupo
            </span>

            <span class="swal-grupo-edicao-value">
              ${marcador?.nome || "Sem nome"}
            </span>

          </div>


          <!-- VEÍCULOS -->
          <div class="swal-grupo-edicao-item">

            <span class="swal-grupo-edicao-label">
              Veículos vinculados
            </span>


            <div class="swal-grupo-edicao-placas">

              ${listaVeiculos.length > 0

          ? listaVeiculos
            .map(
              (veiculo) => `
                          <span class="swal-grupo-edicao-placa">
                            ${veiculo}
                          </span>
                        `
            )
            .join("")

          : `
                      <span class="swal-grupo-edicao-empty">
                        Nenhum veículo vinculado
                      </span>
                    `
        }

            </div>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Editar grupo",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",
      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup: "swal-grupo-edicao-popup",

        title: "swal-grupo-edicao-title",

        htmlContainer: "swal-grupo-edicao-html",

        confirmButton: "swal-grupo-edicao-confirm",

        cancelButton: "swal-grupo-edicao-cancel",

        actions: "swal-grupo-edicao-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,
      heightAuto: false,

    });


    /* =========================================================
       CANCELOU
       ========================================================= */

    if (!result.isConfirmed) {
      return;
    }


    /* =========================================================
       LOADING
       ========================================================= */

    await Swal.fire({

      title: "Abrindo edição...",

      html: `
      <div class="swal-grupo-edicao-loading">

        <div class="swal-grupo-edicao-loading-text">
          Preparando dados do grupo para edição.
        </div>


        <div class="swal-grupo-edicao-loading-spinner">

          <div class="swal-grupo-edicao-spinner"></div>

        </div>


        <div class="swal-grupo-edicao-loading-subtext">
          Aguarde alguns segundos...
        </div>

      </div>
    `,

      allowOutsideClick: false,
      allowEscapeKey: false,

      showConfirmButton: false,

      background: "#0b1722",
      color: "#fff",

      customClass: {
        popup: "swal-grupo-edicao-loading-popup",
        title: "swal-grupo-edicao-loading-title",
        htmlContainer: "swal-grupo-edicao-loading-html",
      },

      buttonsStyling: false,

      scrollbarPadding: false,
      heightAuto: false,

      didOpen: () => {

        setTimeout(() => {

          Swal.close();

          navigate(
            `/maps/grupos-edicao/${marcador.id}`
          );

        }, 1200);

      },

    });

  };



  //EXCLUIR DADOS
  // SELEÇÃO DE DADOS
  const selecionadosInfo = selecionados
    .map((id) => {

      const grupo = marcadores.find(
        (item) => String(item.id) === String(id)
      );

      if (!grupo) return "";

      const nomeGrupo =
        grupo.nome ||
        "Grupo sem nome";

      const placas =
        grupo.placa ||
        grupo.veiculos ||
        grupo.placas ||
        "";

      const possuiVeiculos =
        placas &&
        placas !== "null" &&
        placas !== "undefined" &&
        String(placas).trim() !== "";

      return `
      <div class="swal-exclusao-item">

        <div class="swal-exclusao-item-main">

          <span class="swal-exclusao-item-label">
            Grupo
          </span>

          <span class="swal-exclusao-item-name">
            ${nomeGrupo}
          </span>

        </div>

        ${possuiVeiculos
          ? `
              <div class="swal-exclusao-item-vehicles">

                <span class="swal-exclusao-item-vehicles-label">
                  Veículos
                </span>

                <span class="swal-exclusao-item-vehicles-value">
                  ${String(placas)}
                </span>

              </div>
            `
          : ""
        }

      </div>
    `;
    })
    .join("");



















  const excluirSelecionados = async () => {

    if (selecionados.length === 0) return;


    /* =========================================================
       CONFIRMAÇÃO DE EXCLUSÃO
       ========================================================= */

    const result = await Swal.fire({

      title: "Excluir grupos",

      icon: "warning",
      iconColor: "#f59e0b",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.4rem",

      html: `
    <div class="swal-exclusao">

      <div class="swal-exclusao-description">
        Você está prestes a excluir
        <strong class="swal-exclusao-count">
          ${selecionados.length}
        </strong>
        ${selecionados.length === 1
          ? "grupo"
          : "grupos"
        }.
      </div>


      <div class="swal-exclusao-lista">

        ${selecionadosInfo}

      </div>


      <div class="swal-exclusao-warning">

        <span class="swal-exclusao-warning-icon">
          !
        </span>

        <span>
          Essa ação não poderá ser desfeita.
        </span>

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Excluir",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#dc3f3f",
      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup: "swal-exclusao-popup",

        title: "swal-exclusao-title",

        htmlContainer: "swal-exclusao-html",

        confirmButton: "swal-exclusao-confirm",

        cancelButton: "swal-exclusao-cancel",

        actions: "swal-exclusao-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,

      heightAuto: false,

    });
    /* =========================================================
       CANCELOU
       ========================================================= */

    if (!result.isConfirmed) return;


    try {

      /* =======================================================
         INÍCIO
         ======================================================= */

      const inicio = Date.now();


      /* =======================================================
         LOADING
         ======================================================= */

      Swal.fire({

        title: "Excluindo grupos...",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "390px",
        padding: "1.4rem",

        showConfirmButton: false,

        allowOutsideClick: false,
        allowEscapeKey: false,

        scrollbarPadding: false,

        heightAuto: false,

        html: `
    <div class="swal-grupo-excluindo">

      <div class="swal-grupo-excluindo-loader">

        <div class="swal-grupo-excluindo-spinner"></div>

      </div>


      <div class="swal-grupo-excluindo-text">
        Removendo grupos selecionados
      </div>


      <div class="swal-grupo-excluindo-subtext">
        Aguarde enquanto concluímos a operação.
      </div>

    </div>
  `,

        customClass: {

          popup:
            "swal-grupo-excluindo-popup",

          title:
            "swal-grupo-excluindo-title",

          htmlContainer:
            "swal-grupo-excluindo-html",

        },

        buttonsStyling: false,

      });


      /* =======================================================
         REQUISIÇÃO + DELAY
         ======================================================= */


      await Promise.all([
        Promise.all(
          selecionados.map((id) =>
            api.put(`/grupos/${id}`, {
              ativo: id,
              awsd: "rKhRtfN/nhV4ExudS1OoNqEfJ0B2KsOD8",
              apagado_por: localStorage.getItem("clientID"),
            })
          )
        ),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);

      // Atualiza a lista automaticamente após apagar
      window.dispatchEvent(
        new Event("grupos-atualizados")
      );



      /* =======================================================
         FECHA LOADING
         ======================================================= */

      Swal.close();


      /* =======================================================
         SUCESSO
         ======================================================= */

      await Swal.fire({

        title: "Grupos excluídos",

        icon: "success",
        iconColor: "#22c55e",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "420px",
        padding: "1.5rem",

        timer: 2200,

        timerProgressBar: true,

        showConfirmButton: false,

        scrollbarPadding: false,

        heightAuto: false,

        html: `
        <div class="swal-grupo-excluido">

          <div class="swal-grupo-excluido-description">
            Os grupos selecionados foram removidos
            com sucesso.
          </div>

          <div class="swal-grupo-excluido-count">

            <span>
              ${selecionados.length}
            </span>

            ${selecionados.length === 1
            ? "grupo removido"
            : "grupos removidos"
          }

          </div>

        </div>
      `,

        customClass: {

          popup: "swal-grupo-excluido-popup",

          title: "swal-grupo-excluido-title",

          htmlContainer: "swal-grupo-excluido-html",

          timerProgressBar:
            "swal-grupo-excluido-progress",

        },

      });


      /* =======================================================
         NAVEGAÇÃO
         ======================================================= */

      navigate("/maps/grupos");

      setSelecionados([]);


      /* =======================================================
         ATUALIZA TOTAL
         ======================================================= */

      const { data } = await api.get(
        `/totalgrupos`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );


      const total = data.result;

      setTotalItems(total);


      /* =======================================================
         ATUALIZA PAGINAÇÃO
         ======================================================= */

      const totalPages =
        Math.ceil(total / limit);


      setPages(
        Array.from(
          {
            length: totalPages,
          },
          (_, i) => i + 1
        )
      );


      let newPage =
        currentPage > totalPages
          ? totalPages
          : currentPage;


      if (newPage < 1) {
        newPage = 1;
      }


      setCurrentPage(newPage);


      setMediaPage(
        newPage <= 2
          ? 2
          : newPage
      );


      /* =======================================================
         ATUALIZA TABELA
         ======================================================= */

      await fetchDataCache(
        limit,
        newPage
      );


    } catch (error) {

      /* =======================================================
         ERRO
         ======================================================= */

      console.error(
        "Erro ao excluir grupos:",
        error
      );


      Swal.close();


      Swal.fire({

        title: "Erro ao excluir grupos",

        text:
          "Não foi possível excluir os grupos selecionados. Tente novamente.",

        icon: "error",

        iconColor: "#ef4444",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "420px",
        padding: "1.5rem",

        confirmButtonText: "Entendi",

        scrollbarPadding: false,

        heightAuto: false,

        customClass: {

          popup:
            "swal-grupo-erro-popup",

          title:
            "swal-grupo-erro-title",

          confirmButton:
            "swal-grupo-erro-confirm",

        },

        buttonsStyling: false,

      });

    }

  };


return (
  <>


    <ToastContainer />
     
   
       

    <div className="grupos-page" style={{ paddingTop: 0, minHeight: 0 }}>
          
      
    
      <section className="grupos-panel">
         <Preloader
            show={loading}
            text="Carregando dados dos grupos..."
            customClass="preloader-grupos"
          />
      
          <img src={logo} alt="Logo INOVA" className="logo" />
       
    

        {/* CABEÇALHO */}
        <header className="grupos-ui-header">
    
          <div className="grupos-ui-heading">
            <span className="grupos-ui-heading-icon">
              <Layers size={18} strokeWidth={1.8} />
            </span>

            <div className="grupos-ui-heading-text">
              <h1 className="grupos-ui-title">Grupos</h1>
              <p className="grupos-ui-subtitle">
                Gerencie seus grupos e os veículos vinculados
              </p>
            </div>
          </div>

          <button
            type="button"
            className="grupos-ui-close"
            onClick={() => navigate("/maps")}
            aria-label="Fechar grupos"
            title="Fechar"
          >
            ✕
          </button>
        </header>

        {/* PESQUISA E AÇÕES */}
        <div className="grupos-ui-toolbar">
          <label className="grupos-ui-search" htmlFor="grupos-search">
            <input
              id="grupos-search"
              type="search"
              placeholder="Buscar grupos..."
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              autoComplete="off"
              aria-label="Buscar grupos"
            />

            {searchTerm && (
              <button
                type="button"
                className="grupos-ui-search-clear"
                onClick={() => setSearchTerm("")}
                aria-label="Limpar pesquisa"
                title="Limpar pesquisa"
              >
                ✕
              </button>
            )}
          </label>

          {isAdminState && (
            <div className="grupos-toolbar-actions">
              <Link
                to="/maps/grupos-cad"
                className="grupos-ui-btn-novo"
              >
                <IoMdAdd size={18} />
                <span>Novo grupo</span>
              </Link>
            </div>
          )}
        </div>
        

        {/* TABELA */}
        <div className="grupos-ui-table-area">
         
          <div className="grupos-ui-table-scroll">
            <table className="grupos-ui-table">
              <thead>
                <tr>
                  <th scope="col">Nome do grupo</th>
                  <th scope="col">Veículos vinculados</th>

                  {isAdminState && (
                    <th
                      scope="col"
                      className="grupos-cell-center"
                    >
                      <label
                        className="grupos-select-checkbox"
                        title="Selecionar todos"
                      >
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            marcadores.length > 0 &&
                            selecionados.length === marcadores.length
                          }
                          ref={(input) => {
                            if (input) {
                              input.indeterminate =
                                selecionados.length > 0 &&
                                selecionados.length < marcadores.length;
                            }
                          }}
                          aria-label="Selecionar todos os grupos"
                        />
                        <span />
                      </label>
                    </th>
                  )}
                </tr>
              </thead>

              <tbody>
                {marcadores.map((marcador, index) => {
                  const veiculos = (marcador.veiculos || "")
                    .replace(/'/g, "")
                    .split(",")
                    .map((veiculo) => veiculo.trim())
                    .filter(Boolean);

                  const limite = 3;
                  const veiculosVisiveis = veiculos.slice(0, limite);
                  const restantes = Math.max(
                    0,
                    veiculos.length - limite
                  );

                  return (
                    <tr key={marcador.id || index}>
                      <td>
                        <span className="grupos-nome">
                          {marcador.nome || "—"}
                        </span>
                      </td>

                      <td>
                        {veiculos.length > 0 ? (
                          <div className="grupos-veiculos-lista">
                            {veiculosVisiveis.map((veiculo, i) => (
                              <span
                                className="grupos-veiculo-tag"
                                key={`${veiculo}-${i}`}
                                title={veiculo}
                              >
                                {veiculo}
                              </span>
                            ))}

                            {restantes > 0 && (
                              <Tooltip
                                title={
                                  <div className="grupos-tooltip-veiculos">
                                    {veiculos.slice(limite).map(
                                      (veiculo, i) => (
                                        <div key={`${veiculo}-${i}`}>
                                          {veiculo}
                                        </div>
                                      )
                                    )}
                                  </div>
                                }
                                placement="top"
                                arrow
                              >
                                <span
                                  className="grupos-veiculos-mais"
                                  tabIndex={0}
                                  role="button"
                                  aria-label={`Ver mais ${restantes} veículos`}
                                >
                                  +{restantes}
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        ) : (
                          <span className="grupos-sem-veiculos">
                            Nenhum veículo vinculado
                          </span>
                        )}
                      </td>

                      {isAdminState && (
                        <td className="grupos-cell-center">
                          <div className="grupos-row-actions">
                            <Tooltip
                              title="Editar grupo"
                              arrow
                              placement="bottom"
                            >
                              <button
                                type="button"
                                className="grupos-edit-btn"
                                onClick={() => handleEditar(marcador)}
                                aria-label={`Editar grupo ${marcador.nome}`}
                              >
                                <CiEdit size={22} />
                              </button>
                            </Tooltip>

                            <label
                              className="grupos-select-checkbox"
                              title="Selecionar grupo"
                            >
                              <input
                                type="checkbox"
                                checked={selecionados.includes(marcador.id)}
                                onChange={() =>
                                  handleSelecionar(marcador.id)
                                }
                                aria-label={`Selecionar grupo ${marcador.nome}`}
                              />
                              <span />
                            </label>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}

                {!loading && marcadores.length === 0 && (
                  <tr>
                    <td colSpan={isAdminState ? 3 : 2}>
                      <div className="grupos-ui-empty-state">
                        <CiEdit size={25} />
                        <strong>
                          {searchTerm.trim()
                            ? "Nenhum resultado encontrado"
                            : "Nenhum grupo cadastrado"}
                        </strong>
                        <span>
                          {searchTerm.trim()
                            ? "Tente outro termo de pesquisa."
                            : "Quando houver grupos cadastrados, eles aparecerão aqui."}
                        </span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* SELEÇÃO EM MASSA */}
        {isAdminState && selecionados.length > 0 && (
          <div className="grupos-bulk-actions">
            <span>
              {selecionados.length}{" "}
              {selecionados.length === 1
                ? "grupo selecionado"
                : "grupos selecionados"}
            </span>

            <Tooltip
              title="Excluir selecionados"
              arrow
              placement="top"
            >
              <button
                type="button"
                className="grupos-delete-selected"
                onClick={excluirSelecionados}
              >
                <MdDeleteForever size={19} />
                <span>Excluir selecionados</span>
              </button>
            </Tooltip>
          </div>
        )}

        {/* RODAPÉ E PAGINAÇÃO */}
        <footer className="grupos-ui-footer">
          <div className="grupos-ui-total">
            <span>
              <strong>{totalItems}</strong>{" "}
              {totalItems === 1 ? "grupo" : "grupos"}
            </span>

            <span className="grupos-ui-total-separator" />

            <span>
              Página <strong>{pages.length ? currentPage : 0}</strong>{" "}
              de <strong>{pages.length}</strong>
            </span>
          </div>

          <nav
            className="grupos-ui-pagination"
            aria-label="Paginação dos grupos"
          >
            <button
              type="button"
              className="grupos-ui-page-btn"
              onClick={() => handlePagination(currentPage - 1)}
              disabled={currentPage <= 1 || loading}
              aria-label="Página anterior"
            >
              «
            </button>

            {getVisiblePages(currentPage, pages.length).map(
              (page, index) => (
                <React.Fragment key={`${page}-${index}`}>
                  {page === "..." ? (
                    <span className="grupos-ui-page-dots">…</span>
                  ) : (
                    <button
                      type="button"
                      className={`grupos-ui-page-btn ${
                        page === currentPage ? "active" : ""
                      }`}
                      onClick={() => handlePagination(page)}
                      disabled={loading}
                      aria-current={
                        page === currentPage ? "page" : undefined
                      }
                    >
                      {page}
                    </button>
                  )}
                </React.Fragment>
              )
            )}

            <button
              type="button"
              className="grupos-ui-page-btn"
              onClick={() => handlePagination(currentPage + 1)}
              disabled={
                currentPage >= pages.length || loading
              }
              aria-label="Próxima página"
            >
              »
            </button>
          </nav>

          <label className="grupos-ui-limit">
            <span>Exibir</span>

            <select
              value={limit}
              onChange={limits}
              aria-label="Quantidade de grupos por página"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              {totalItems > 0 && (
                <option value={totalItems}>
                  Todos ({totalItems})
                </option>
              )}
            </select>

            <span>por página</span>
          </label>
        </footer>
      </section>
    </div>
  </>
);
}
export default Cadastro;
